import { SharedVacancy } from './pages/SharedVacancy';

export function ClientApp() {
  const shareToken = new URLSearchParams(window.location.search).get('share');

  if (shareToken) {
    return <SharedVacancy shareToken={shareToken} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <img
          src="/NEEDLES Logo (Rechthoekig).svg"
          alt="Needles Logo"
          className="h-12 mx-auto mb-6"
        />
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">Welkom bij Needles</h2>
        <p className="text-gray-600">Gebruik de link die je van je consultant hebt ontvangen om je campagne te bekijken.</p>
      </div>
    </div>
  );
}
